export default {
  // GET Requests //

  // Gets integration data
  async getIntegrationData(context) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let integrations;
    let carriers;

    try {
      integrations = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/integrations/retrieve-all-by-company/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      integrations = await integrations.json();

      carriers = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/integrations/retrieve-carriers",
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      carriers = await carriers.json();
    } catch (err) {
      return 500;
    }

    for (let i = 0; i < carriers.carriers.length; i++) {
      carriers.carriers[i].carrierId = carriers.carriers[i]._id;
    }

    for (let i = 0; i < carriers.features.length; i++) {
      carriers.features[i].featureId = carriers.features[i]._id;
    }

    context.commit("integrations", integrations.integrations);
    context.commit("carriers", carriers.carriers);
    context.commit("features", carriers.features);
    context.commit("integrationTimestamp");

    return 200;
  },
  // Checks if the connection exists
  async getConnectionExists(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/integrations/check-connection-exists/" +
          companyId +
          "/" +
          payload.carrierId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    return {
      status: 200,
      connectionId: response.connectionId,
      exists: response.exists,
    };
  },

  // POST Requests //

  // Create and test a conneciton
  async postConnection(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/integrations/add-connection",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            carrierId: payload.carrierId,
            credentials: payload.credentials,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    return response;
  },
  // Create and test a conneciton
  async postIntegrationCallback(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/integrations/add-authorization",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            integrationId: payload.integrationId,
            authorizationCode: payload.authorizationCode,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let integrationPayload = context.state.integrations;
    for (let i = 0; i < integrationPayload.length; i++) {
      if (integrationPayload[i].integrationId == response.integrationId) {
        integrationPayload[i].connected = true;
        break;
      }
    }
    context.commit("integrations", integrationPayload);

    return 201;
  },
  // Create a integration
  async postIntegration(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/integrations/add-integration",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            carrierId: payload.carrierId,
            connectionId: payload.connectionId,
            type: payload.type,
            enabled: true,
            features: [],
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    let integrationPayload = context.state.integrations;
    integrationPayload.push(response.integration);
    context.commit("integrations", integrationPayload);

    return {
      status: 201,
      integrationId: response.integration.integrationId,
    };
  },

  // PATCH Requests //

  // Update an integration
  async patchIntegration(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/integrations/update-integration",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            integrationId: payload.integrationId,
            enabled: payload.enabled,
            features: payload.features,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    let integrationPayload = context.state.integrations;
    for (let i = 0; i < integrationPayload.length; i++) {
      if (
        integrationPayload[i].integrationId ==
        response.integration.integrationId
      ) {
        integrationPayload[i].features = response.integration.features;
        integrationPayload[i].enabled = response.integration.enabled;
        break;
      }
    }
    context.commit("integrations", integrationPayload);

    return 200;
  },
  // DELETE Requests //

  // Remove an integration
  async deleteIntegration(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];

    try {
      await fetch(
        process.env.VUE_APP_NODE_SERVER + "/integrations/remove-integration",
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            integrationId: payload.integrationId,
          }),
        }
      );
    } catch (err) {
      return 500;
    }

    let integrationPayload = context.state.integrations.filter(
      (integration) => integration.integrationId != payload.integrationId
    );

    context.commit("integrations", integrationPayload);

    return 201;
  },
};
